var _a;
import { generateSelectors } from "../generators/generator.selectors";
import { GENERATOR_PARAMS, REDUCER_KEY } from "./payin.constants";
export var getPaged = (_a = generateSelectors(GENERATOR_PARAMS), _a.getPaged), getDetail = _a.getDetail;
export var isRefunding = function (state, id) {
    var _a, _b;
    return ((_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.refund) === null || _b === void 0 ? void 0 : _b[id])
        ? state[REDUCER_KEY].refund[id].isRefunding
        : false;
};
export var refundError = function (state, id) {
    var _a, _b;
    return ((_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.refund) === null || _b === void 0 ? void 0 : _b[id])
        ? state[REDUCER_KEY].refund[id].refundError
        : undefined;
};
